import { LandingController } from "controllers/LandingController";
import { MockModuleController } from "controllers/MockModuleController";
import { FlexController } from "controllers/FlexController";

// Order of controllers is important here
export const controllers = [MockModuleController, FlexController, LandingController];
